import React from "react";
import pic from "../../../icons/conf.jpg";


class ConfidentalLeft extends React.Component {
    render() {
        return (
            <div className='word-wrap'>
                <h2>Site sensitivity label</h2>
                <div style={{marginTop:'30px'}}>Please choose sensitivity label of your site</div>
                <img className="left-pane-pic" style={{marginTop:'50px', width:'180px', height:'180px'}} src={pic} alt="Logo" />
            </div>
        );
    }
}
export default ConfidentalLeft







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/ConfidentialityLeft.js